import React, { Suspense, useMemo } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import { fixedtRouteList, setHomeRoute, setRoute } from '@routes/routePath';
import { AnimatePresence } from 'framer-motion';
import { getPathKey } from '@utils/getPath';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import { ACCESS_TYPE } from '@typings/common/accessType';
import ProtectedRoute from './ProtectedRoute';
import { useRecoilValue } from 'recoil';
import { boardSetListState } from '@atom/setting/boardSetListState';
import NoMatch from '@pages/404/NoMatch';

function RootRoute() {
  const location = useLocation();
  const customRoute = useMemo(
    () => setRoute({ data: masterSet.boardSet }) || [],
    [],
  );

  const homeRoute = setHomeRoute();

  // 📍 중앙화된 보드셋 리스트 사용 (기존 useCollection 대체)
  const boardSetList = useRecoilValue(boardSetListState);
  const safeBoardSetList = boardSetList || [];
  const isBoardRoutesReady = !!boardSetList;
  const fallbackBgColor = useMemo(() => {
    if (typeof window === 'undefined') return '#111';
    const fromVar = document.documentElement.style
      .getPropertyValue('--backgroundColor')
      .trim();
    return fromVar || '#111';
  }, [location.pathname]);
  return (
    <>
      <AnimatePresence exitBeforeEnter>
        <Suspense
          fallback={
            <div
              style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: fallbackBgColor,
                zIndex: 9999,
              }}
            />
          }
        >
          <Routes key={`/${getPathKey(0)}`}>
            {isBoardRoutesReady &&
              homeRoute && <Route path="/" element={homeRoute[0].component} />}

            {isBoardRoutesReady &&
              customRoute.map((routeList, index) => {
                const { path, component } = routeList;

                // 실제 게시판 수와 route설정은 다름
                const findIndex = safeBoardSetList.findIndex(
                  (board) => `/${board.path}` === path,
                );

                return (
                  <Route
                    key={index}
                    path={path}
                    element={
                      <>
                        <ProtectedRoute
                          accessType={
                            findIndex >= 0
                              ? safeBoardSetList[findIndex].accessType
                              : ACCESS_TYPE.PUBLIC
                          }
                        >
                          {component}
                        </ProtectedRoute>
                      </>
                    }
                  />
                );
              })}

            {fixedtRouteList.map((routeList, index) => {
              const { path, component, accessType } = routeList;
              return (
                <Route
                  key={index}
                  path={path}
                  element={
                    <ProtectedRoute accessType={accessType}>
                      {component}
                    </ProtectedRoute>
                  }
                />
              );
            })}
            <Route
              path="*"
              element={
                isBoardRoutesReady ? (
                  <NoMatch />
                ) : (
                  <div
                    style={{
                      position: 'fixed',
                      inset: 0,
                      backgroundColor: fallbackBgColor,
                      zIndex: 9999,
                    }}
                  />
                )
              }
            />
            {/* {homeRoute && (
              <Route
                path={`${homeRoute[0].path}`}
                element={homeRoute[0].component}
              />
            )} */}
          </Routes>
        </Suspense>
      </AnimatePresence>
    </>
  );
}

export default RootRoute;
